import { render, staticRenderFns } from "./MovimientoForm.vue?vue&type=template&id=65666a90&"
import script from "./MovimientoForm.vue?vue&type=script&lang=js&"
export * from "./MovimientoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports